module.exports = __webpack_public_path__ + "26614ae2adec971f3a38177478a1e736.svg";